'use strict';

var _classCallCheck = require("C:\\Repos\\ewconverter-material\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var RTFParagraph = function RTFParagraph(opts) {
  _classCallCheck(this, RTFParagraph);

  if (!opts) opts = {};
  this.style = opts.style || {};
  this.content = [];
};

module.exports = RTFParagraph;